import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import BizAddNewCourt from './components/Business/BizAddNewCourt';
import BizProfile from './components/Business/BizProfile';
import BizCompanyPro from './components/Business/BizProPages/BizCompanyPro';
import BizCourtBook from './components/Business/BizProPages/BizCourtBook';
import BizScheduler from './components/Business/BizScheduler.jsx/BizScheduler';
import BizSignUpComp from './components/Business/BizSignUp/BizSignUpComp';
import Footer from './components/Home component/Footer';
import Navbar from './components/Home component/Navbar';
import About from './pages/About';
import BookCourt from './pages/BookCourt';
import BookingDone from './pages/BookingDone';
import Home from './pages/Home';
import Login from './pages/Login';
import MyAccount from './pages/MyAccount/MyAccount';
import MyAccPayment from './pages/MyAccount/MyAccPayment';
import Notifi from './pages/MyAccount/Notifi';
import RateUs from './pages/RateUs';
import Search from './pages/Search';
import SignUp from './pages/SignUp';
import Thanks from './pages/Thanks';
function App() {
  return (
    <div className="App">
        {/* <Navbar/>  */}
         {/* <Home/>
         <Login/>  */}
         {/* <SignUp/>  */}
         {/* <Search/> 
         <BookCourt/>  */}
         {/* <BookingDone/>  */}
          {/* <RateUs/>  */}
          {/* <Thanks/>  */}
          {/* <MyAccount/>  */}
          {/* <MyAccPayment/>  */}
          {/* <Notificaton/>  */}
          {/* <About/>  */}
  
           
    <Router>
    <Navbar/> 
      <Routes>
     <Route path="/" element={<Home />}></Route>
     <Route  path="/search" element={<Search />}></Route>
     <Route path="/BookCourt" element={<BookCourt />}></Route>
     <Route path="/About" element={<About />}></Route>
     <Route path="/MyAccount" element={<MyAccount />}></Route>
     <Route path="/Login" element={<Login />}></Route>
     <Route path="*" element={<Home />}></Route>
 

     <Route path="/signup" element={<SignUp />}></Route>
     <Route path="/bookingDone" element={<BookingDone />}></Route>
     <Route path="/rateUs" element={<RateUs />}></Route>
     <Route path="/thanks" element={<Thanks />}></Route>
     <Route path="/myaccpayment" element={<MyAccPayment/>}></Route>

     <Route path="/BizSignUpComp" element={<BizSignUpComp/>}></Route>
     <Route path="/BizProfile" element={<BizProfile/>}></Route>
     <Route path="/BizAddNewCourt" element={<BizAddNewCourt/>}></Route>

     <Route path="/notifi" element={<Notifi />}></Route>



 
     
      </Routes>
    </Router>
 



          <Footer/>
    </div>
  );
}

export default App;
